/**
 * The illustration skin in effect: the dev/cheats override, else the subscriber's own "Book style"
 * choice (Settings, live config `enableSkinSelector`; skins B/C are included in the subscription —
 * MONETIZATION-PLAN §8 / decisions 2026-10-18), else the live config `artStyle` (default 'storybook' = A).
 */
import { artStyleId } from '@sketchling/core';
import { useAccess, useApp } from '../state/store';
import { useMoney } from '../lib/billing';
import type { StyleId } from './tokens';

export function useArtStyle(): StyleId {
  const override = useApp((s) => s.cheats.artStyle);
  const live = useApp((s) => s.config.artStyle);
  const selector = useApp((s) => s.config.enableSkinSelector);
  const choice = useMoney((s) => s.skin);
  const { premium, unlockAll } = useAccess();
  const mine = selector && (premium || unlockAll) ? choice : null;
  return artStyleId(override ?? mine ?? live);
}
